import  { DateRangeOptions, WeekStartsOn } from '@playvox/almendra/dist/types/src/components/datepicker/date-utils';
import type {
    DateFilter,
    SelectFilter,
    FilterType
} from '@playvox/almendra/dist/types/src/components/filter/filterConfiguration';
import { useOrganisationDetails } from '@agyletime/vue-3-common/src/composables/useOrganisationDetails';
import { SimpleFilter } from '@agyletime/vue-3-common/src/components/FilterBar/utils/definitions/BaseItem';
import { ApiQueryParams } from '@/pages/OperationsInsights/types/ApiQueryParams';
import { ref, computed } from 'vue';
import { useActiveWsDefOperationConfigRefDataStore } from '@/stores/activeWsDefOperationConfigRefDataStore';

const { organisationDetails } = useOrganisationDetails();

export function useFilterConfig() {
    const { activeWsDefOperationConfigRefDataStore } = useActiveWsDefOperationConfigRefDataStore();
    const date: DateFilter = {
        key: 'date',
        type: 'Date' as FilterType.Date,
        enabled: true,
        required: true,
        label: 'Date',
        range: true,
        value: '',
        weekStartsOn: (organisationDetails.startWeekOn as WeekStartsOn) ?? 1,
        rangeOptions: [
            'Today',
            'Yesterday',
            'This Week',
            'Last Week',
            'This Month',
            'Last Month'
        ] as DateRangeOptions[]
    };

    const workstreamDefinitions = computed((): SelectFilter => ({
        key: 'workstreamDefinitions',
        enabled: true,
        required: true,
        label: 'Workstream Definitions',
        type: 'Select' as FilterType.Select,
        value: '',
        options: (activeWsDefOperationConfigRefDataStore.data || []).map((ws) => ({
            value: ws.workstreamDefinitionId,
            displayValue: ws.name
        }))
    }));

    const filterConfig = computed(() => [ date, workstreamDefinitions.value ]);

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const queryParams = ref<ApiQueryParams>({
        fromDate: new Date(yesterday),
        toDate: new Date(yesterday),
        workstreamDefinitionIds: []
    });

    const onApply = async (params: SimpleFilter) => {
        const updates: Partial<ApiQueryParams> = {};

        if (params.date) {
            const [ dateFrom, dateTo ] = params.date as Date[];
            updates.fromDate = new Date(dateFrom);
            updates.toDate = new Date(dateTo);
        }

        if (params.workstreamDefinitions) {
            updates.workstreamDefinitionIds = Array.isArray(params.workstreamDefinitions)
                ? params.workstreamDefinitions as number[]
                : [params.workstreamDefinitions as number];
        }

        Object.assign(queryParams.value, updates);
    };

    return {
        filterConfig,
        queryParams,
        onApply
    };
}